import * as React from 'react';
import * as globalStyles from 'styles/style.scss';
import * as style from './styles.scss';
import { Button } from 'react-bootstrap';
import { Dropdown, Fallback, NumericInput } from 'components/common';
import {
  IEquityAssetInfoMarginCallByResponse,
  IEquityBankInfoResponse,
} from 'interfaces/api';
import { IState } from 'redux/global-reducers';
import { SystemType } from 'constants/enum';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { formatNumber, handleError } from 'utils/common';
import { prefixAccount, allowOnlyNumbers } from '../../utils';
import { showNotification } from '../../action';
import { withErrorBoundary } from 'react-error-boundary';
import CommonError from '../CommonError';
import {
  queryEquityCalculateInterestAmt,
  queryEquityCalculateInterestAmt1,
  queryEquityCashAdvancedAmount,
  resetEquityCalculateInterestAmt,
  resetEquityCalculateInterestAmt1,
} from 'components/areas/Account/CashAdvanced/actions';
import classNames from 'classnames';
import OtpOnceModal from '../OtpOnceModal';
import { WarningTransfer } from 'assets/svg';
export interface IDropdownData {
  readonly title: string;
  readonly value: string;
}

export interface IBeneficiaryProps
  extends React.ClassAttributes<BeneficiaryComponent>,
    WithNamespaces {
  readonly selectedAccount: IState['selectedAccount'];
  readonly userInfo: IState['userInfo'];
  readonly otp: IState['otp'];
  readonly otpToken: IState['otpToken'];
  readonly globalBankInfo: IState['bankInfo'];
  readonly equityBankInfo: IState['equityBankInfo'];
  readonly equityCashTransferResult: IState['equityCashTransferResult'];
  readonly equityTransferableAmount: IState['equityTransferableAmount'];
  readonly derivativeInternalCashTransferResult: IState['derivativeInternalCashTransferResult'];
  readonly derivativeBankCashTransferResult: IState['derivativeBankCashTransferResult'];
  readonly VSDCashTransferResult: IState['VSDCashTransferResult'];
  readonly equitySubAccount: IState['equitySubAccount'];
  readonly accountList: IState['accountList'];
  readonly equityCashAdvancedAmount: IState['equityCashAdvancedAmount'];
  readonly equityCashAdvancedInterestAmt: IState['equityCashAdvancedInterestAmt'];
  readonly equityCashAdvancedInterestAmt1: IState['equityCashAdvancedInterestAmt1'];

  readonly transferAmount: number;
  readonly transferableAmount?: number;
  readonly content: string;
  readonly isTransferToBank?: boolean;
  readonly accountData?: IDropdownData[] | [];
  readonly modalTitle: string;
  readonly isVSD?: boolean;
  readonly isWithdrawVSD?: boolean;
  readonly bankInfo?: IEquityBankInfoResponse;
  readonly currentStep?: number;
  readonly accountBalance?: IEquityAssetInfoMarginCallByResponse;
  readonly onChangeContent: (content: string) => void;
  readonly onChangeTransferAmount: (amount: number) => void;
  readonly onChangeAdvanceAmount?: (amount: number) => void;
  readonly onConfirm: (otpToken?: string) => void;
  readonly onChangeBeneficiaryAccount: (
    account: string,
    bankName?: string
  ) => void;
  readonly onReset: () => void;
  readonly showNotification: typeof showNotification;
  readonly queryEquityCashAdvancedAmount: typeof queryEquityCashAdvancedAmount;
  readonly queryEquityCalculateInterestAmt: typeof queryEquityCalculateInterestAmt;
  readonly queryEquityCalculateInterestAmt1: typeof queryEquityCalculateInterestAmt1;
  readonly resetEquityCalculateInterestAmt: typeof resetEquityCalculateInterestAmt;
  readonly resetEquityCalculateInterestAmt1: typeof resetEquityCalculateInterestAmt1;
  readonly onChangeBankName?: (bankName: string) => void;
  readonly onChangeBranchName?: (branchId: string, branchName: string) => void;
  readonly allowToNextStep?: (step: string) => void;
  readonly onChangeStep?: (step: number) => void;
  readonly onChangeFee?: (fee: number) => void;
}

interface IBeneficiaryState {
  readonly isShowModal: boolean;
  readonly beneficiaryAccount?: string;
  readonly transferAmount: number;
  readonly bankName: string;
  readonly branchName: string;
  readonly isShowError: boolean;
  readonly mvAmountList: any;
  readonly mvInterestAmtList: any;
}

const MIN_TRANSFER_AMOUNT_BANK = 50000;
class BeneficiaryComponent extends React.Component<
  IBeneficiaryProps,
  IBeneficiaryState
> {
  constructor(props: IBeneficiaryProps) {
    super(props);
    this.state = {
      isShowModal: false,
      beneficiaryAccount: '',
      transferAmount: 0,
      bankName: '',
      branchName: '',
      isShowError: false,
      mvAmountList: { mvAmount1: 0, mvAmount2: 0 },
      mvInterestAmtList: {
        mvInterestAmt1: 0,
        mvInterestAmt2: 0,
      },
    };
  }

  componentDidMount() {
    if (this.props.selectedAccount?.type === SystemType.EQUITY) {
      this.props.queryEquityCashAdvancedAmount({
        accountNo: this.props.selectedAccount.accountNumber,
      });
    }
    if (this.props.isVSD) {
      if (this.props.isWithdrawVSD) {
        this.props.onChangeBeneficiaryAccount(
          this.props.selectedAccount?.account as string
        );
        this.setState({
          beneficiaryAccount: this.props.selectedAccount?.account,
        });
      }
      this.props.onChangeBeneficiaryAccount(
        prefixAccount() + this.props.userInfo?.username
      );
      this.setState({
        beneficiaryAccount: this.props.userInfo?.username,
      });
    }

    this.setState({ beneficiaryAccount: this.props.accountData?.[0]?.title });
  }

  shouldComponentUpdate(
    nextProps: IBeneficiaryProps,
    nextState: IBeneficiaryState
  ) {
    if (this.props.accountData !== nextProps.accountData) {
      this.setState({
        beneficiaryAccount: nextProps.accountData?.[0]?.title,
      });
      if (nextProps.accountData?.[0]?.title) {
        this.props.onChangeBeneficiaryAccount(
          nextProps.accountData?.[0]?.title,
          nextProps.accountData?.[0]?.value
        );
      }
    }
    return true;
  }

  componentDidUpdate(
    prevProps: IBeneficiaryProps,
    prevState: IBeneficiaryState
  ) {
    if (
      this.props.equityCashAdvancedInterestAmt !==
        prevProps.equityCashAdvancedInterestAmt ||
      this.props.equityCashAdvancedInterestAmt1 !==
        prevProps.equityCashAdvancedInterestAmt1
    ) {
      this.setState(
        {
          mvInterestAmtList: {
            mvInterestAmt1: Number(
              this.props.equityCashAdvancedInterestAmt.data?.interestAmt ?? 0
            ),
            mvInterestAmt2: Number(
              this.props.equityCashAdvancedInterestAmt1.data?.interestAmt ?? 0
            ),
          },
        },
        () => {
          this.props.onChangeFee?.(
            Number(
              this.props.equityCashAdvancedInterestAmt.data?.interestAmt ?? 0
            ) +
              Number(
                this.props.equityCashAdvancedInterestAmt1.data?.interestAmt ?? 0
              )
          );
        }
      );
    }
    if (
      this.props.selectedAccount &&
      this.props.selectedAccount.type === SystemType.EQUITY
    ) {
      if (
        this.props.equityTransferableAmount.data?.mvRequiredAdvAmt !==
          prevProps.equityTransferableAmount.data?.mvRequiredAdvAmt &&
        this.props.equityTransferableAmount.data?.mvRequiredAdvAmt != null
      ) {
        if (this.props.equityTransferableAmount.data?.mvRequiredAdvAmt !== 0) {
          this.handleCaculateFee(
            Math.ceil(
              this.props.equityTransferableAmount.data?.mvRequiredAdvAmt
            )
          );
        } else {
          this.onResetAdvanceAmount();
        }
      }
      if (
        this.state.mvAmountList.mvAmount1 !== prevState.mvAmountList.mvAmount1
      ) {
        if (this.state.mvAmountList.mvAmount1 !== 0) {
          this.props.queryEquityCalculateInterestAmt({
            accountNumber: this.props.selectedAccount.accountNumber,
            mvAmount: this.state.mvAmountList.mvAmount1.toString(),
            mvSettlement: '2',
          });
        } else {
          this.props.resetEquityCalculateInterestAmt();
        }
      }
      if (
        this.state.mvAmountList.mvAmount2 !== prevState.mvAmountList.mvAmount2
      ) {
        if (this.state.mvAmountList.mvAmount2 !== 0) {
          this.props.queryEquityCalculateInterestAmt1({
            accountNumber: this.props.selectedAccount.accountNumber,
            mvAmount: this.state.mvAmountList.mvAmount2.toString(),
            mvSettlement: '3',
          });
        } else {
          this.props.resetEquityCalculateInterestAmt1();
        }
      }
    }
    if (
      this.props.currentStep !== prevProps.currentStep &&
      this.props.currentStep === 2
    ) {
      this.setState({
        isShowModal: true,
      });
    }
    if (
      this.props.bankInfo?.bankName &&
      this.props.bankInfo?.bankName !== prevProps.bankInfo?.bankName
    ) {
      this.setState({
        beneficiaryAccount: this.props.bankInfo?.bankId,
        bankName: this.props.bankInfo?.bankName,
        branchName: this.props.bankInfo?.bankBranchName || '',
      });
    }
    if (
      this.props.selectedAccount &&
      this.props.selectedAccount !== prevProps.selectedAccount &&
      this.props.selectedAccount.type === SystemType.EQUITY
    ) {
      this.props.queryEquityCashAdvancedAmount({
        accountNo: this.props.selectedAccount.accountNumber,
      });
    }
    if (
      (this.props.bankInfo !== prevProps.bankInfo && !this.props.bankInfo) ||
      this.props.selectedAccount !== prevProps.selectedAccount
    ) {
      this.onResetAdvanceAmount();
      this.setState({
        beneficiaryAccount: '',
        bankName: '',
        branchName: '',
      });
    }
  }

  render() {
    const { t, bankInfo, isTransferToBank } = this.props;
    const { transferAmount } = this.state;
    const { mvInterestAmtList } = this.state;
    const contentTransferInternal = `${t('CONTENT_INTERNAL')} ${
      this.props.selectedAccount?.account
    } ${t('to ')} ${this.state.beneficiaryAccount}`;
    const contentTransferToBank = `${t('CONTENT_BANK')} ${
      this.props.selectedAccount?.account
    } ${this.props.selectedAccount?.accountName}`;
    const contentDepositVSD = `${t('CONTENT_DEPOSIT')} ${
      this.props.selectedAccount?.account
    } ${this.props.selectedAccount?.accountName}`;
    const contentWithdrawVSD = `${t('CONTENT_WITHDRAW')} ${
      prefixAccount() + this.props.userInfo?.username
    } ${this.props.selectedAccount?.accountName}`;

    const customStyleHideNoDataBranch = {
      visibility:
        (bankInfo?.bankBranchName ?? this.state.branchName) !== ''
          ? 'visible'
          : 'hidden',
    } as { [key: string]: string };

    const renderBeneficiaryForBankEquity = (
      <>
        <div>
          <p className={style.BenificiaryBankName}>{t("Beneficiary's Bank")}</p>
          <div className={style.BenificiaryTextBox} title={bankInfo?.bankName}>
            {bankInfo?.bankName ?? this.state.bankName}
          </div>
        </div>
        <div style={customStyleHideNoDataBranch}>
          <p className={style.BenificiaryBranch}>{t('Branch')}</p>
          <div
            className={style.BenificiaryTextBox}
            title={bankInfo?.bankBranchName}
          >
            {bankInfo?.bankBranchName ?? this.state.branchName}
          </div>
        </div>
        <div className={style.BenificiaryTitle1}>
          {t('Cash Transfer Information')}
        </div>
        <div className={style.CashTransferInformation}>
          <p>{t('Transfer Amount1')}</p>
          <div className={style.BenificiaryInput}>
            <div className="NumericInput">
              <div className="react-numeric-input">
                <NumericInput
                  onNumberChange={this.onChangeTransferAmount}
                  onKeyPress={allowOnlyNumbers}
                  value={transferAmount}
                  error={
                    this.state.isShowError &&
                    this.props.selectedAccount?.type ===
                      SystemType.DERIVATIVES &&
                    (Number(transferAmount) < 1 ||
                      Number(this.props.transferableAmount) < 1 ||
                      Number(transferAmount) >
                        Number(this.props.transferableAmount))
                  }
                  errorMessage={
                    Number(transferAmount) < 1
                      ? t('INVALID_TRANSFER_AMOUNT')
                      : t('Exceeding Transferable Amount')
                  }
                />
              </div>
            </div>
          </div>
        </div>
        {
          <div
            className={style.CashTransferInformation}
            style={{
              visibility:
                this.props.selectedAccount?.type === SystemType.DERIVATIVES
                  ? 'hidden'
                  : 'visible',
            }}
          >
            <p>{t('Advance Amount')}</p>
            <div className={style.BenificiaryAdvanceAmt}>
              <p style={{ width: '100%' }} className={style.BenificiaryTextBox}>
                {formatNumber(
                  Math.ceil(
                    this.props.equityTransferableAmount.data
                      ?.mvRequiredAdvAmt ?? 0
                  )
                ) + ' VNĐ'}{' '}
                {'('}
                {t('Advance Fee')}:{' '}
                {formatNumber(
                  mvInterestAmtList.mvInterestAmt1 +
                    mvInterestAmtList.mvInterestAmt2
                )}
                {')'}
              </p>
              <p
                style={{
                  color:
                    (this.props.equityTransferableAmount.data
                      ?.mvRequiredAdvAmt ?? 0) > 0
                      ? '#b0b8ce'
                      : 'red',
                }}
              >
                {t(
                  this.props.equityTransferableAmount.data?.withdrawWRNMsg ||
                    (this.state.transferAmount > 0 &&
                    this.state.transferAmount < MIN_TRANSFER_AMOUNT_BANK
                      ? 'The minimum amount that can be withdrawn is 50,000 VND. Please re-enter.'
                      : '')
                )}
              </p>
            </div>
          </div>
        }
        <div className={style.CashTransferInformation1}>
          <p>{t('Content')}</p>
          <div
            className={`${style.BenificiaryInput} ${style.BenificiaryTextBox}`}
          >
            <div>
              {this.props.isVSD
                ? this.props.isWithdrawVSD
                  ? this.onChangeContent(contentWithdrawVSD)
                  : this.onChangeContent(contentDepositVSD)
                : this.props.isTransferToBank
                ? this.onChangeContent(contentTransferToBank)
                : this.onChangeContent(contentTransferInternal)}
            </div>
          </div>
        </div>
      </>
    );
    const renderBeneficiaryForInternal = (
      <>
        <div>
          <p className={style.BenificiaryBankName}></p>
        </div>
        <div>
          <p className={style.BenificiaryBranch}></p>
        </div>
        <div className={style.BenificiaryTitle1}>
          {t('Cash Transfer Information')}
        </div>
        <div className={style.CashTransferInformation}>
          <p>{t('Transfer Amount1')}</p>
          <div className={style.BenificiaryInput}>
            <div className="NumericInput">
              <div className="react-numeric-input">
                <NumericInput
                  onNumberChange={this.onChangeTransferAmount}
                  onKeyPress={allowOnlyNumbers}
                  value={transferAmount}
                  error={
                    this.state.isShowError &&
                    this.props.selectedAccount?.type ===
                      SystemType.DERIVATIVES &&
                    (Number(transferAmount) < 1 ||
                      Number(this.props.transferableAmount) < 1 ||
                      Number(transferAmount) >
                        Number(this.props.transferableAmount))
                  }
                  errorMessage={
                    Number(transferAmount) < 1
                      ? t('INVALID_TRANSFER_AMOUNT')
                      : t('Exceeding Transferable Amount')
                  }
                />
              </div>
            </div>
          </div>
        </div>
        {
          <div
            className={style.CashTransferInformation}
            style={{
              visibility:
                this.props.selectedAccount?.type === SystemType.DERIVATIVES
                  ? 'hidden'
                  : 'visible',
            }}
          >
            <p>{t('Advance Amount')}</p>
            <div className={style.BenificiaryAdvanceAmt}>
              <p style={{ width: '100%' }} className={style.BenificiaryTextBox}>
                {formatNumber(
                  Math.ceil(
                    this.props.equityTransferableAmount.data
                      ?.mvRequiredAdvAmt ?? 0
                  )
                ) +
                  ` VNĐ (${t('Advance Fee')}: ${formatNumber(
                    mvInterestAmtList.mvInterestAmt1 +
                      mvInterestAmtList.mvInterestAmt2
                  )} VNĐ)`}
              </p>
              <p
                style={{
                  color:
                    (this.props.equityTransferableAmount.data
                      ?.mvRequiredAdvAmt ?? 0) > 0
                      ? '#b0b8ce'
                      : 'red',
                }}
              >
                {t(
                  this.props.equityTransferableAmount.data?.withdrawWRNMsg ?? ''
                )}
              </p>
            </div>
          </div>
        }
        <div className={style.CashTransferInformation1}>
          <p>{t('Content')}</p>
          <div
            className={`${style.BenificiaryInput} ${style.BenificiaryTextBox}`}
          >
            <div>
              {this.props.isVSD
                ? this.props.isWithdrawVSD
                  ? this.onChangeContent(contentWithdrawVSD)
                  : this.onChangeContent(contentDepositVSD)
                : this.props.isTransferToBank
                ? this.onChangeContent(contentTransferToBank)
                : this.onChangeContent(contentTransferInternal)}
            </div>
          </div>
        </div>
      </>
    );
    return (
      <>
        <div className={style.BenificiaryNew}>
          <div className={style.BenificiaryTitle}>
            <p>{t('Beneficiary Acc.Info')}</p>
          </div>
          <div className={style.BenificiaryContent}>
            <div className={style.BenificiaryRight}>
              <div>
                <p>{t('Beneficiary Account No')}</p>
                <div className={globalStyles.Container}>
                  <div className={style.BenificiaryDropdown}>
                    {this.props.isVSD ? (
                      this.props.isWithdrawVSD ? (
                        <p>{this.props.selectedAccount?.account}</p>
                      ) : (
                        <p>{prefixAccount() + this.props.userInfo?.username}</p>
                      )
                    ) : (
                      <>
                        <Dropdown
                          isForm={true}
                          onSelect={this.onChangeAccount}
                          data={this.props.accountData}
                          placeholder={this.state.beneficiaryAccount}
                          isResetInput={
                            !this.state.beneficiaryAccount || Boolean(bankInfo)
                          }
                          tabMode={true}
                        />
                      </>
                    )}
                  </div>
                  <CommonError
                    error={
                      this.state.isShowError &&
                      !this.state.beneficiaryAccount &&
                      !this.props.isVSD
                    }
                    errorMessage={t('Required')}
                  />
                </div>
              </div>
              <div>
                <p>{t("Beneficiary's Name")}</p>
                <p className={style.BenificiaryTextBoxUppercase}>
                  {bankInfo?.ownerName ??
                    this.props.selectedAccount?.accountName}
                </p>
              </div>

              {this.props.isTransferToBank && renderBeneficiaryForBankEquity}
              {!this.props.isTransferToBank && renderBeneficiaryForInternal}

              <div className={style.WarningBoxCashTransfer}>
                <WarningTransfer />
                <div className={style.Right}>
                  <div>{t('Note:')}</div>
                  <ul>
                    <li dangerouslySetInnerHTML={{
                      __html: t(`NoteTrans1`),
                    }}></li>
                    <li>{t('NoteTrans2')}</li>
                    <li>{t('NoteTrans3')}</li>
                  </ul>
                </div>
              </div>

              <div className={style.BenificiaryButton}>
                <Button
                  bsPrefix={globalStyles.DarkButton}
                  className={classNames({
                    [style.disabledBtn]:
                      !transferAmount ||
                      Number(transferAmount) < 1 ||
                      Number(this.props.transferableAmount) < 1 ||
                      Number(transferAmount) >
                        Number(this.props.transferableAmount),
                  })}
                  onClick={() => {
                    this.props.onChangeStep?.(0);
                    this.onReset();
                  }}
                >
                  {t('Cancel')}
                </Button>
                <Button
                  bsPrefix={globalStyles.QueryButton}
                  type="submit"
                  onClick={this.onShowModal}
                  className={classNames({
                    [style.disabledBtn]:
                      !transferAmount ||
                      (isTransferToBank &&
                        Number(transferAmount) < MIN_TRANSFER_AMOUNT_BANK) ||
                      Number(transferAmount) < 1 ||
                      Number(this.props.transferableAmount) < 1 ||
                      Number(transferAmount) >
                        Number(this.props.transferableAmount),
                  })}
                >
                  {t('Next')}
                </Button>
              </div>
            </div>
          </div>
        </div>
        {this.props.isTransferToBank ? (
          <OtpOnceModal
            show={this.state.isShowModal}
            onHide={this.onHideModal}
            onSubmit={this.onConfirmTransfer}
          >
            <div className={style.CashTransferModal}>
              <p className={style.CashTransferModalTitle}>
                {t(this.props.modalTitle)}
              </p>
              <div>
                <p>{t('Sender Acc.No')}</p>
                <p>{this.props.selectedAccount?.account}</p>
              </div>
              <div>
                <p>{t("Beneficiary's Account")}</p>
                <p>{this.state.beneficiaryAccount}</p>
              </div>
              <div>
                <p>{t('Beneficiary Acc')}</p>
                <p>
                  {bankInfo?.ownerName ??
                    this.props.selectedAccount?.accountName}
                </p>
              </div>
              <div>
                <p>{t('Bank:')}</p>
                <p>{bankInfo?.bankName ?? this.state.bankName}</p>
              </div>
              <div style={customStyleHideNoDataBranch}>
                <div>{t('Branch:')}</div>
                <div>{bankInfo?.bankBranchName ?? this.state.branchName}</div>
              </div>
              <hr />
              <div>
                <p>{t('Transfer amount:')}</p>
                <p>{formatNumber(transferAmount)}</p>
              </div>
              {this.props.isVSD && (
                <div>
                  <p>{t('Transfer fee:')}</p>
                  <p>{formatNumber(5500)}</p>
                </div>
              )}
              <div>
                <div className={style.content}>
                  <p>{t('Content')}</p>
                  <div className={style.contentNote}>
                    {this.props.isVSD
                      ? this.props.isWithdrawVSD
                        ? contentWithdrawVSD
                        : contentDepositVSD
                      : contentTransferToBank}
                  </div>
                </div>
              </div>
            </div>
          </OtpOnceModal>
        ) : (
          <OtpOnceModal
            show={this.state.isShowModal}
            onHide={this.onHideModal}
            onSubmit={this.onConfirmTransfer}
          >
            <div className={style.CashTransferModal}>
              <p className={style.CashTransferModalTitle}>
                {t(this.props.modalTitle)}
              </p>
              <div>
                <p>{t('Sender Acc')}</p>
                <p>{this.props.selectedAccount?.account}</p>
              </div>
              <div>
                <div>{t('Receiver Acc')}</div>
                <div>
                  {this.props.isVSD
                    ? this.props.isWithdrawVSD
                      ? this.props.selectedAccount?.account
                      : `${prefixAccount() + this.props.userInfo?.username}`
                    : this.state.beneficiaryAccount}
                </div>
              </div>
              <hr/>
              <div>
                <p>{t('Transfer amount:')}</p>
                <p>
                  {formatNumber(transferAmount || this.props.transferAmount)}
                </p>
              </div>
              <div>
                <div className={style.content}>
                  <p>{t('Content')}</p>
                  <div className={style.contentNote}>
                    {this.props.isVSD
                      ? this.props.isWithdrawVSD
                        ? contentWithdrawVSD
                        : contentDepositVSD
                      : contentTransferInternal}
                  </div>
                </div>
              </div>
            </div>
          </OtpOnceModal>
        )}
      </>
    );
  }

  private onChangeContent = (content: string) => {
    this.props.onChangeContent(content);
    return content;
  };

  private onChangeAccount = (title: string, value: string) => {
    const beneficiaryAccount = this.props.equityBankInfo.data?.find(
      (val) => val.bankId === title && val.bankName === value
    );
    this.setState({
      beneficiaryAccount: title,
      branchName: beneficiaryAccount?.bankBranchName ?? '',
      bankName: beneficiaryAccount?.bankName ?? '',
    });
    this.props.onChangeBeneficiaryAccount(title, value);
  };

  private onShowModal = () => {
    this.setState({ isShowError: true });
    if (
      !this.props.isVSD &&
      (this.state.beneficiaryAccount === '' ||
        !this.state.beneficiaryAccount ||
        (this.props.isTransferToBank &&
          ((this.state.bankName === '' &&
            this.props.bankInfo?.bankName === '') ||
            (this.state.branchName === '' &&
              this.props.bankInfo?.bankName === '' &&
              this.props.selectedAccount?.type !== SystemType.DERIVATIVES))))
    ) {
      return;
    }
    if (this.props.selectedAccount?.type === SystemType.DERIVATIVES) {
      if (
        this.props.transferableAmount &&
        this.state.transferAmount <= this.props.transferableAmount &&
        this.state.transferAmount > 0
      ) {
        this.props.onChangeStep?.(1);
      }
    } else {
      if (
        this.props.transferableAmount &&
        this.state.transferAmount > 0 &&
        this.state.transferAmount -
          (this.props.equityTransferableAmount.data?.mvBalance ?? 0) <=
          Number(
            this.props.equityCashAdvancedAmount.data?.availableCashAdvance
          ) &&
        this.state.transferAmount <=
          Number(this.props.equityTransferableAmount.data?.transferableAmount)
      ) {
        this.props.onChangeStep?.(1);
      }
    }
  };

  private onConfirmTransfer = (otpToken?: string) => {
    this.props.onConfirm(otpToken);
    if (this.props.selectedAccount?.type === SystemType.DERIVATIVES) {
      this.onReset();
    }
    this.props.onChangeStep?.(3);
  };

  private handleCaculateFee = (stcw: number) => {
    const equityCashAdvancedAmount = this.props.equityCashAdvancedAmount.data;
    if (equityCashAdvancedAmount != null) {
      const mvAmount_1 = Math.min(
        stcw,
        equityCashAdvancedAmount.t1AdvAvailable
      );

      const mvAmount_2 = Math.max(
        0,
        Math.min(equityCashAdvancedAmount.t0AdvAvailable, stcw - mvAmount_1)
      );

      if (mvAmount_1 !== 0 || mvAmount_2 !== 0) {
        this.setState({
          mvAmountList: {
            mvAmount1: mvAmount_1,
            mvAmount2: mvAmount_2,
          },
        });
      }
    }
  };

  private onChangeTransferAmount = (value: number) => {
    this.setState({ transferAmount: value });
    this.props.onChangeTransferAmount(value);
  };

  private onResetAdvanceAmount = () => {
    this.setState({
      mvAmountList: { mvAmount1: 0, mvAmount2: 0 },
      mvInterestAmtList: {
        mvInterestAmt1: 0,
        mvInterestAmt2: 0,
      },
    });
    this.props.onChangeAdvanceAmount?.(0);
    this.props.onChangeFee?.(0);
  };

  private onHideModal = () => {
    if (this.props.currentStep === 2) {
      this.props.onChangeStep?.(1);
    }
    this.setState({ isShowModal: false });
  };

  private onReset = () => {
    this.props.onReset();
    !this.props.isTransferToBank &&
      !this.props.isVSD &&
      this.props.onChangeBeneficiaryAccount(
        this.state.beneficiaryAccount ?? ''
      );
    this.setState({
      transferAmount: 0,
      beneficiaryAccount: this.props.bankInfo
        ? this.props.bankInfo.bankId
        : this.state.beneficiaryAccount,
      branchName: this.props.bankInfo?.bankBranchName
        ? this.props.bankInfo?.bankBranchName
        : '',
      bankName: this.props.bankInfo ? this.props.bankInfo.bankName : '',
      isShowError: false,
    });
  };
}

const mapStateToProps = (state: IState) => ({
  selectedAccount: state.selectedAccount,
  userInfo: state.userInfo,
  otp: state.otp,
  otpToken: state.otpToken,
  globalBankInfo: state.bankInfo,
  equityBankInfo: state.equityBankInfo,
  equityCashTransferResult: state.equityCashTransferResult,
  derivativeBankCashTransferResult: state.derivativeBankCashTransferResult,
  VSDCashTransferResult: state.VSDCashTransferResult,
  derivativeInternalCashTransferResult:
    state.derivativeInternalCashTransferResult,
  equitySubAccount: state.equitySubAccount,
  accountList: state.accountList,
  equityCashAdvancedAmount: state.equityCashAdvancedAmount,
  equityCashAdvancedInterestAmt: state.equityCashAdvancedInterestAmt,
  equityCashAdvancedInterestAmt1: state.equityCashAdvancedInterestAmt1,
  equityTransferableAmount: state.equityTransferableAmount,
});

const mapDispatchToProps = {
  showNotification,
  queryEquityCashAdvancedAmount,
  queryEquityCalculateInterestAmt,
  queryEquityCalculateInterestAmt1,
  resetEquityCalculateInterestAmt,
  resetEquityCalculateInterestAmt1,
};

const Beneficiary = withErrorBoundary(
  withNamespaces('common')(
    connect(mapStateToProps, mapDispatchToProps)(BeneficiaryComponent)
  ),
  Fallback,
  handleError
);

export default Beneficiary;



// WEBPACK FOOTER //
// ./src/components/areas/Account/CashTransfer1/Common/BeneficiaryNew/index.tsx